import { render, staticRenderFns } from "./CamerasMonitoring.vue?vue&type=template&id=b0508d82&"
import script from "./CamerasMonitoring.vue?vue&type=script&lang=js&"
export * from "./CamerasMonitoring.vue?vue&type=script&lang=js&"
import style0 from "./CamerasMonitoring.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports